import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import style from './style.module.css';

const AppToolbarComponent = ({ className, children }) => (
  <div className={classNames(style.host, className)}>{children}</div>
);

AppToolbarComponent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

/** White page toolbar under the app header: page-level buttons, tabs and filters. */
export const AppToolbar = memo(AppToolbarComponent);
